import { ITextData } from 'types/textData'
import { BiLike } from 'react-icons/bi'
import { FaRegUser, FaShippingFast } from 'react-icons/fa'
import { MdPriceCheck, MdCreditScore } from 'react-icons/md'
import { RiSecurePaymentFill } from 'react-icons/ri'
import { ImagesAboutProduct } from 'images/about'

const initialState: ITextData = {
  shippingList: [
    { id: 1, label: 'наличный расчет;' },
    { id: 2, label: 'безналичный расчет.' },
  ],
  calculationList: [
    { id: 1, label: 'самовывоз розничной или оптовой продукции со склада;' },
    {
      id: 2,
      label:
        'возможна доставка оптовой продукции по всей Беларуси и странам Европейского союза.',
    },
  ],
  aboutProductImages: [
    { id: 1, img: ImagesAboutProduct.ImageProduct_1 },
    { id: 2, img: ImagesAboutProduct.ImageProduct_2 },
    { id: 3, img: ImagesAboutProduct.ImageProduct_3 },
    { id: 4, img: ImagesAboutProduct.ImageProduct_4 },
    { id: 5, img: ImagesAboutProduct.ImageProduct_5 },
    { id: 6, img: ImagesAboutProduct.ImageProduct_6 },
    { id: 7, img: ImagesAboutProduct.ImageProduct_7 },
    { id: 8, img: ImagesAboutProduct.ImageProduct_8 },
    { id: 9, img: ImagesAboutProduct.ImageProduct_9 },
    { id: 10, img: ImagesAboutProduct.ImageProduct_10 },
    { id: 11, img: ImagesAboutProduct.ImageProduct_11 },
    { id: 12, img: ImagesAboutProduct.ImageProduct_12 },
    { id: 13, img: ImagesAboutProduct.ImageProduct_13 },
    { id: 14, img: ImagesAboutProduct.ImageProduct_14 },
    { id: 15, img: ImagesAboutProduct.ImageProduct_15 },
    { id: 16, img: ImagesAboutProduct.ImageProduct_16 },
  ],
  aboutBenefitsGrid: [
    {
      id: 1,
      IconTag: BiLike,
      label: 'Гарантия 10 лет',
      description:
        'Cответствие изделий заданным характеристикам за счет испытаний в лаборатории',
    },
    {
      id: 2,
      IconTag: FaRegUser,
      label: 'Квалифицированные специалисты',
      description:
        'Специалисты с опытом работы более 20 лет в производстве изделий из пластмасс и уплотнителей',
    },
    {
      id: 3,
      IconTag: FaShippingFast,
      label: 'Доставка',
      description:
        'Доставка оптовой продукции по Беларуси и странам Европейского союза',
    },
    {
      id: 4,
      IconTag: MdPriceCheck,
      label: 'Низкие цены',
      description: 'Мы имеем низкие цены благодаря полному циклу производства',
    },
    {
      id: 5,
      IconTag: RiSecurePaymentFill,
      label: 'Удобная оплата',
      description: 'Мы принимаем, как наличный так и безналичный расчет',
    },
    {
      id: 6,
      IconTag: MdCreditScore,
      label: 'Отсрочка платежа',
      description:
        'Для постоянных покупателей мы предусмотрели отсрочку платежа',
    },
  ],
  soglashenie: {
    userHasRight: [
      { id: 1, text: '— осуществлять поиск информации на сайте;' },
      { id: 2, text: '— получать информацию на сайте;' },
      { id: 3, text: '— комментировать контент, выложенный на сайте;' },
      {
        id: 4,
        text: '— копировать информацию на другие сайты с указанием источника;',
      },
      {
        id: 5,
        text: '— копировать информацию на другие сайты с разрешения Администрации сайта;',
      },
      {
        id: 6,
        text: '— копировать информацию на другие сайты с разрешения правообладателя;',
      },
      {
        id: 7,
        text: '— требовать от Администрации скрытия любой информации о пользователе;',
      },
      {
        id: 8,
        text: '— требовать от Администрации скрытия любой информации, переданной пользователем сайту;',
      },
      {
        id: 9,
        text: '— использовать информацию сайта в личных некоммерческих целях.',
      },
    ],
    adminHasRight: [
      {
        id: 1,
        text: '— по своему усмотрению и необходимости создавать, изменять, отменять правила;',
      },
      { id: 2, text: '— ограничивать доступ к любой информации на сайте;' },
      { id: 3, text: '— создавать, изменять, удалять информацию;' },
      { id: 4, text: '— удалять учетные записи;' },
      { id: 5, text: '— отказывать в регистрации без объяснения причин.' },
    ],
    userUndertakes: [
      { id: 1, text: '— обеспечить достоверность предоставляемой информации;' },
      {
        id: 2,
        text: '— обеспечивать сохранность личных данных от доступа третьих лиц;',
      },
      { id: 3, text: '— не копировать информацию с других источников;' },
      {
        id: 4,
        text: '— не распространять информацию, которая направлена на пропаганду войны, разжигание национальной, расовой или религиозной ненависти и вражды, а также иной информации, за распространение которой предусмотрена уголовная или административная ответственность;',
      },
      { id: 5, text: '— не нарушать работоспособность сайта;' },
      {
        id: 6,
        text: '— не создавать несколько учётных записей на Сайте, если фактически они принадлежат одному и тому же лицу;',
      },
      {
        id: 7,
        text: '— не совершать действия, направленные на введение других Пользователей в заблуждение;',
      },
      {
        id: 8,
        text: '— не передавать в пользование свою учетную запись и/или логин и пароль своей учетной записи третьим лицам;',
      },
      {
        id: 9,
        text: '— не регистрировать учетную запись от имени или вместо другого лица за исключением случаев, предусмотренных законодательством РБ;',
      },
      {
        id: 10,
        text: '— не размещать материалы рекламного, эротического, порнографического или оскорбительного характера, а также иную информацию, размещение которой запрещено или противоречит нормам действующего законодательства РБ;',
      },
      {
        id: 11,
        text: '— не использовать скрипты (программы) для автоматизированного сбора информации и/или взаимодействия с Сайтом и его Сервисами.',
      },
    ],
    adminUndertakes: [
      {
        id: 1,
        text: '— поддерживать работоспособность сайта за исключением случаев, когда это невозможно по независящим от Администрации причинам;',
      },
      {
        id: 2,
        text: '— осуществлять разностороннюю защиту учетной записи Пользователя;',
      },
      {
        id: 3,
        text: '— защищать информацию, распространение которой ограничено или запрещено законами путем вынесения предупреждения либо удалением учетной записи пользователя, нарушившего правила;',
      },
      {
        id: 4,
        text: '— предоставить всю доступную информацию о Пользователе уполномоченным на то органам государственной власти в случаях, установленных законом.',
      },
    ],
    responsibilityParties: [
      {
        id: 1,
        text: '— пользователь лично несет полную ответственность за распространяемую им информацию;',
      },
      {
        id: 2,
        text: '— Администрация не несет никакой ответственности за достоверность информации, скопированной из других источников;',
      },
      {
        id: 3,
        text: '— Администрация не несёт ответственность за несовпадение ожидаемых Пользователем и реально полученных услуг;',
      },
      {
        id: 4,
        text: '— Администрация не несет никакой ответственности за услуги, предоставляемые третьими лицами;',
      },
      {
        id: 5,
        text: '— в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное положение, стихийное бедствие и т. д.) Администрация не гарантирует сохранность информации, размещённой Пользователем, а также бесперебойную работу информационного ресурса.',
      },
    ],
  },
  allVacancy: [
    {
      id: 1,
      title: 'Бухгалтер',
      tags: [
        { id: 1, label: 'Требуемый опыт работы: от 1 года' },
        { id: 2, label: 'Полная занятость' },
        { id: 3, label: 'Полный день' },
      ],
      responsibilities: [
        { id: 1, label: '— Обработка и ввод первичной документации;' },
        { id: 2, label: '— Учет товаров (оприходование, реализация);' },
        { id: 3, label: '— Проведение и разнесение выписок в базе;' },
        {
          id: 4,
          label:
            '— Ведение делопроизводства (входящая/исходящая корреспонденция, отправка почтовых отправлений);',
        },
        { id: 5, label: '— Выписка накладных по мере необходимости;' },
        {
          id: 6,
          label: '— Другие распоряжения и поручения главного бухгалтера.',
        },
      ],
      requirements: [
        {
          id: 1,
          label: '— Высшее или средне-специальное образование (бухучет);',
        },
        { id: 2, label: '— Навыки работы с 1С:8.3;' },
        {
          id: 3,
          label:
            '— Знание всех участков бухгалтерского учёта и законодательства;',
        },
        {
          id: 4,
          label:
            '— Внимательность, точность в деталях, ответственность, обучаемость, исполнительность;',
        },
        { id: 5, label: '— Уверенный пользователь ПК.' },
      ],
      terms: [
        { id: 1, label: '— График: 5/2 с 9:00 до 17:00 (сб, вс - выходные);' },
        { id: 2, label: '— Работа в районе п. Михановичи;' },
        { id: 3, label: '— Испытательный срок — 1 месяц;' },
        {
          id: 4,
          label:
            '— Стабильная и своевременная зарплата от 800 белорусских рублей «на руки».',
        },
      ],
    },
    {
      id: 2,
      title: 'Оператор экструзии',
      tags: [
        { id: 1, label: 'Требуемый опыт работы: 1-3 года' },
        { id: 2, label: 'Полная занятость' },
        { id: 3, label: 'Сменный график' },
      ],
      responsibilities: [
        { id: 1, label: '— Запуск и настройка экструзионных линий;' },
        { id: 2, label: '— Загрузка сырья;' },
        { id: 3, label: '— Разборка и чистка формообразующего инструмента;' },
        { id: 4, label: '— Упаковка произведённой продукции;' },
        { id: 5, label: '— Контроль качества выпускаемой продукции;' },
        { id: 6, label: '— Устранение типичных неисправностей на линии.' },
      ],
      requirements: [
        { id: 1, label: '— Без вредных привычек;' },
        {
          id: 2,
          label:
            '— Техническая грамотность (опыт работы на промышленном предприятии или техническое  образование), навыки слесарной работы;',
        },
        {
          id: 3,
          label: '— Способность выполнения несложного оперативного ремонта;',
        },
        { id: 4, label: '— Желание работать.' },
      ],
      terms: [
        { id: 1, label: '— Место работы: р-н п. Михановичи;' },
        { id: 2, label: '— Компенсация расходов на проезд к месту работы;' },
        { id: 3, label: '— Испытательный срок — 1 месяц;' },
        {
          id: 4,
          label:
            '— На время испытательного срока сдельная оплата труда 1000 - 1200 BYN «на руки».',
        },
      ],
    },
  ],
}

export const textDataReducer = (state = initialState): ITextData => state
